<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 sm4 offset-sm4>
   			<v-card>
	   			<v-card-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="400px" v-if="hasCreateAccess">
              <v-btn slot="activator" round color="primary" dark small class="ml-4">Add New</v-btn>
              <v-form v-model="validForm">
                <v-card>
                  <v-card-title>
                    <span class="headline" v-text="item.id ? 'Update Customer Type' : 'Add Customer Type'"></span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md py-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field :rules="rules" counter="50" v-model="item.title" label="Customer Type"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea counter="250" v-model="item.description" label="Description"></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="customerTypes"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
				      <td>{{ props.item.title }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn :item="props.item" />
                <delete-btn :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !customerTypes.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(customerTypes)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'CustomerTypes',
    data () {
      return {
        model: 'customertype',
      	title: "Customer Types",
        validForm: false,
      	processing: false,
        dialog: false,
        deleteDialog: false,
      	customerTypes: [],
        headers: [
          { text: 'Customer Type', value: 'title'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        defaultItem: {
          id: "",
          title: "",
          description: "",
          is_deleted: false
        },
        deletingItem: null,
        rules: [
          v => !!v || 'Customer Type is required',
          v => v && v.length >= 3 || 'Must be more than 2 characters',
          v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ]
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Customer Types',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Customer Types')
    },
    methods: {

      addItem () {
        this.processing = true
        this.axios.post(this.config.apis.addCustomerType, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let new_item = Object.assign({}, this.item)
              new_item.id = response.data.data.id

              this.customerTypes.unshift(new_item)

              this.notifySuccess('insertSuccess')
              this.close()
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.close()
          })
      },
      updateItem () {
      	this.processing = true
        this.axios.put(this.config.apis.updateCustomerType.replace(":id", this.item.id), this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              this.notifySuccess('updateSuccess')
              this.close()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.close()
          })
      },

      editItem (item) {
        this.item = item
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      }

    },
    mounted () {
    	this.getAllData()
        .then( response => {
          this.customerTypes = response
        })
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {

    }

  }
</script>
